module.exports = __webpack_public_path__ + "img/goodreads.02819c45.svg";